<template>
  <div :class="[$style.Container, isMobileUa ? $style.ContainerMobile : null]">
    <div
      :class="[$style.Tab, props.active === tab.value ? $style.TabActive : null]"
      v-for="tab in props.tabs"
      :key="tab.value"
      @click="handleActive(tab.value)"
      >{{ tab.title }}
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { Tab } from './type';
  import type { SKU_TYPE } from '../../constants';
  import { getIsMobileUa } from '../../utils/ua';

  const isMobileUa = getIsMobileUa();

  interface Props {
    tabs: Tab[];
    active: SKU_TYPE;
  }

  const props = defineProps<Props>();
  const emits = defineEmits(['update:active']);

  function handleActive(value: SKU_TYPE) {
    if (value === props.active) {
      return;
    }

    emits('update:active', value);
  }
</script>

<style lang="less" module>
  .Container {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: rgba(18, 18, 18, 1);
    padding: 4px;
    height: 42px;
    border-radius: 20px;
  }

  .Tab {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;

    cursor: pointer;

    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0%;
    color: rgba(255, 255, 255, 0.45);
  }

  .Tab.TabActive {
    background-color: rgba(255, 255, 255, 0.12);
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.85);
    border-radius: 20px;
  }
</style>
